
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKURepricingDetailsGrid extends Serenity.EntityGrid<SKURepricingDetailsRow, any> {
        protected getColumnsKey() { return 'Inventory.SKURepricingDetails'; }
        protected getDialogType() { return SKURepricingDetailsDialog; }
        protected getIdProperty() { return SKURepricingDetailsRow.idProperty; }
        protected getInsertPermission() { return SKURepricingDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return SKURepricingDetailsRow.localTextPrefix; }
        protected getService() { return SKURepricingDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}